export const PAGES = {
  START_PAGE: 'start_page',
  SUBSCRIBE_PAGE: 'subscribe_page',
  PICTURE_PAGE: 'picture_page',
};

export const COLORS = {
  GOLD: '#e3d572',
  ERROR: '#ff7a45',
  BUTTON: '#de5d83',
  BUTTON_DARK: '#C5446A',
  COMING_SOON: '#53585f',
};

export const LINKS = {
  FACEBOOK: 'https://www.facebook.com/SerenaWilliams/',
  TWITTER: 'https://twitter.com/serenawilliams',
  INSTAGRAM: 'https://www.instagram.com/serenawilliams/',
};



// WEBPACK FOOTER //
// ./src/util/constants.js